import React from "react";
import MarketingLocationPage from "./MarketingLocationPage";

export default function DigitaleVermarktungWolfsberg() {
  return <MarketingLocationPage locationKey="wolfsberg" />;
}
